import type { CreateApplicationStageConfig } from './types';

export const createClosedStageConfig: CreateApplicationStageConfig = () => ({
  badge: { id: 'closed', label: 'Closed', color: 'error' },
  getAttributes: () => [],
  getActions: () => [],
  getActiveProcessesProps: () => ({ items: [] }),
});
